import { Outlet, Navigate } from 'react-router-dom'
import { URLS } from './index'

import { useAuthStatus } from '../store/selectors/userSelector'

const PrivateRoutes = () => {
    const isAuth = useAuthStatus()
    return isAuth ? <Outlet /> : <Navigate data-testid="navigate" to={URLS.HOME} />
}

export default PrivateRoutes
